module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-wrapper"
  }, [(Object.keys(_vm.assoc).length) ? _c('div', {
    staticClass: "attach-layer attach-layer-selected"
  }, [_c('div', {
    staticClass: "attach-info ii"
  }, [_c('div', {
    staticClass: "__cover",
    style: ({
      'background-image': 'url(' + _vm.attachCover + ')'
    })
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('v-icon', {
    staticClass: "attach-cancel cursor-pointer",
    on: {
      "click": function($event) {
        _vm.removeAttach()
      }
    }
  }, [_vm._v("\n      add\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thought-attachment"
  }, [_c('div', {
    staticClass: "thought-attachment-previews"
  }, [_c('div', {
    staticClass: "_preview add-attachment dflex align-center justify-center",
    on: {
      "click": function($event) {
        _vm.show_attach_picker = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.truncAttachment), function(attachment, index) {
    return _c('div', {
      key: index,
      staticClass: "_preview mb-1",
      class: [_vm.getCustomClass(attachment)],
      style: ({
        'background-image': 'url(' + _vm.getBGUrl(attachment) + ')'
      }),
      on: {
        "click": function($event) {
          _vm.selectAttachment({
            type: _vm.getAssocType(attachment),
            value: attachment,
          })
        }
      }
    })
  })], 2)]), _vm._v(" "), (_vm.show_attach_picker) ? _c('attach-picker', {
    attrs: {
      "dismiss": _vm.closeAttachPicker,
      "title": "Add Attachment",
      "customAlbums": _vm.albums,
      "customProducts": _vm.products,
      "fullscreen": ""
    },
    on: {
      "getSelected": _vm.selectAttachment
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__details"
  }, [_c('div', {
    staticClass: "_title"
  }), _vm._v(" "), _c('div', {
    staticClass: "_info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a08b18c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/attachSlide.vue
// module id = 1826
// module chunks = 180